<template>
  <ul class="stats">
    <li>{{ downloads }} downloads</li>
    <li>{{ stars }} stars</li>
    <li>{{ contributors }} contributors</li>
  </ul>
</template>

<script>
const json = res => res.json();

const noop = () => {
  // Do nothing.
};

const data = {
  downloads: `N/A`,
  stars: `N/A`,
  contributors: 'N/A',
  fetching: false,
};

const getYearTimespans = () => {
  const timespans = [];

  for (let year = 2020; year <= new Date().getFullYear(); year++) {
    timespans.push(`${year}-01-01:${year}-12-31`);
  }

  return timespans;
};

export default {
  name: 'stats',

  data() {
    return data;
  },

  beforeMount() {
    this.fetch();
  },

  methods: {
    async fetch() {
      if (this.fetching) return;
      this.fetching = true;

      const [stars, contributors, ...downloadChunks] = await Promise.all([
        fetch('https://api.github.com/repos/fnbrjs/fnbr.js').then(json, noop),
        fetch('https://api.github.com/repos/fnbrjs/fnbr.js/stats/contributors').then(json, noop),
        ...getYearTimespans().map(s => fetch(`https://api.npmjs.org/downloads/range/${s}/fnbr`).then(json, noop)),
      ]);

      if (downloadChunks) {
        const totalDownloads = downloadChunks.map(dc => dc.downloads.map(d => d.downloads)).flat().reduce((a, b) => a + b, 0);
        this.downloads = totalDownloads.toLocaleString();
      }
      if (stars) this.stars = stars.stargazers_count.toLocaleString();
      if (contributors) this.contributors = contributors.length.toLocaleString();
    },
  },
};
</script>
